// extracted by mini-css-extract-plugin
export default {"input-item":"FormItem_input-item__KauvK"};